(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-header"]) return;
  try {
    
import('@shopify/events').then(({ StandardEvents }) => {
  document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
    event.promise?.then(({ cart, detail }) => {
      const count = cart?.totalQuantity ?? detail?.itemCount;
      if (!Number.isInteger(count) || count < 0) return;
      document.querySelectorAll('.rs-bag-count').forEach((element) => {
        element.textContent = String(count);
      });
    }).catch(() => {});
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-trade-collection"]) return;
  try {
    
  document.querySelectorAll('[data-rst-sort]').forEach((sel) => {
    sel.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-trade-enquiry-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const params = new URLSearchParams(window.location.search);
    const lot = params.get('lot');
    const field = document.querySelector('[data-rst-lot]');
    if (lot && field && !field.value) field.value = lot;
    if (params.has('contact_posted') || window.location.hash === '#rs-enquiry') {
      const el = document.getElementById('enquiry-form');
      if (el) el.scrollIntoView({ block: 'start' });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-trade-header"]) return;
  try {
    
import('@shopify/events').then(({ StandardEvents }) => {
  document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
    event.promise?.then(({ cart, detail }) => {
      const count = cart?.totalQuantity ?? detail?.itemCount;
      if (!Number.isInteger(count) || count < 0) return;
      document.querySelectorAll('.rst-cart-count').forEach((el) => { el.textContent = String(count); });
    }).catch(() => {});
  });
}).catch(() => {});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-trade-signup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (new URLSearchParams(window.location.search).has('customer_posted')) {
      var el = document.getElementById('trade-alerts');
      if (el) el.scrollIntoView({ block: 'center' });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
